<template>
	<div>
		<bread-crumbs
			:title="$t('Zonification.Zonification')"
			:subTitle="$t('general.SubTitleZonification')"
			:sizeTitle="30"
			:lineHeightTitle="37"
			:sizeSubTitle="15"
			:lineHeightSubTitle="18"
		>
		</bread-crumbs>
		<div class="vx-row">
			<div class="vx-col md:w-2/5 w-full mb-base">
				<vx-card>
					<vs-tabs
						v-model="activeTab"
						alignment="fixed"
						class="tab-action-btn-fill-conatiner"
						:color="colorTabs"
					>
						<!-- MODE VIEW -->
						<vs-tab
							v-show="zonificationReadPermission"
							icon=""
							:label="$t('Zonification.View')"
							@click="colorTabs = '#F9841E'"
						>
							<div :style="{height: windowHeight < 600 ? '100%' : 31.6 + 'rem'}">
								<div class="vx-row">
									<div class="vx-col md:w-1/1 w-full">
										<!--Layers -->
										<div class="mt-4">
											<label
												class="vs-input--label g-label"
												v-text="$t('general.Selectt') + ' ' + $t('Zonification.Layers')"
											></label>
											<v-select
												v-model="selectedLayer"
												:options="layerOptions"
												:dir="$vs.rtl ? 'rtl' : 'ltr'"
												:default-expand-level="1"
												:placeholder="$t('Select')"
											>
												<template v-slot:no-options="{search, searching}">
													<template v-if="searching">
														{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
													</template>
												</template>
											</v-select>
										</div>
									</div>
									<div class="vx-col md:w-1/1 w-full">
										<!--Layers -->
										<div class="mt-4">
											<label
												class="vs-input--label g-label"
												v-text="$t('general.Selectt') + ' ' + $t('Zonification.Zones')"
											></label>
											<treeselect
												value-consists-of="LEAF_PRIORITY"
												v-model="zones"
												openDirection="bottom"
												:default-expand-level="1"
												:multiple="true"
												:options="optionsMulti"
												:placeholder="$t('Select')"
											/>
										</div>
									</div>
									<div class="vx-col md:w-1/1 w-full"></div>
								</div>
							</div>
						</vs-tab>
						<!-- MODE CREATE DRAW -->
						<vs-tab
							v-if="activeTab === 1 ? 'colorTabs = red' : 'colorTabs = blue'"
							v-show="zonificationCreatePermission || zonificationUpdatePermission"
							icon=""
							:label="
								$t('Zonification.Draw') + ' / ' + $t('Crud.Update') + ' ' + $t('Zonification.Layers')
							"
						>
							<div :style="{height: windowHeight < 600 ? '100%' : 31.6 + 'rem'}">
								<div class="vx-row">
									<div class="vx-col md:w-1/1 w-full">
										<!--Layers -->
										<div class="mt-4">
											<label class="vs-input--label">{{ $t("Zonification.Layers") }}</label>
											<v-select
												v-model="selectedLayer"
												:options="layerOptions"
												:dir="$vs.rtl ? 'rtl' : 'ltr'"
												:placeholder="$t('Select')"
											>
												<template v-slot:no-options="{search, searching}">
													<template v-if="searching">
														{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
													</template>
												</template>
											</v-select>
										</div>
									</div>
									<div class="vx-col md:w-1/1 w-full">
										<vs-alert
											class="mt-4"
											color="success"
											title="Agregar zonas"
											:active.sync="alertPolygon"
											closable
											icon-pack="feather"
											close-icon="icon-x"
										>
											<span>{{ $t("Zonification.UseTool") }} </span>
											<span class="text-inherit underline" style="cursor: pointer">
												<feather-icon
													class="cursor-pointer"
													icon="HexagonIcon"
													svgClasses="h-4 w-4"
												/>
												{{ $t("Zonification.Polygon") }}
											</span>
											<span>{{ $t("Zonification.DrawAndAddZones") }}</span>
										</vs-alert>
									</div>
									<div class="vx-col md:w-1/1 w-full">
										<!--Layers -->
										<div class="mt-4">
											<label class="vs-input--label">{{ $t("Zonification.Zones") }}</label>
											<treeselect
												value-consists-of="LEAF_PRIORITY"
												v-model="zones"
												openDirection="bottom"
												:default-expand-level="1"
												:multiple="true"
												:options="optionsMulti"
												:placeholder="$t('Select')"
											/>
										</div>
									</div>

									<div class="vx-col md:w-1/1 w-full"></div>
								</div>
							</div>
						</vs-tab>
						<!-- MODE ASSIG RESOURCE -->
						<vs-tab
							:label="$t('Resource.AssigResources')"
							icon=""
							class="tabResponsive"
							v-show="zonificationReadPermission"
						>
							<hr class="mt-2" />
							<div :style="{height: windowHeight < 600 ? '100%' : 31.6 + 'rem'}">
								<div class="vx-row">
									<div class="vx-col md:w-1/1 w-full">
										<ul v-if="assignedResources.length > 0">
											<li
												class="cursor-pointer"
												v-for="resource in assignedResources"
												:key="resource.uid"
											>
												<resource-item
													:resource="resource"
													:removeAssignedResource="removeAssignedResource"
												></resource-item>
											</li>
										</ul>
										<p v-if="assignedResources.length === 0">
											<vs-alert
												class="mt-2"
												closable
												icon-pack="feather"
												close-icon="icon-x"
												color="success"
												style="overflow-y: auto"
												:active.sync="activeAlert2"
												:title="$t('Resource.AssigResources')"
											>
												{{ $t("Zonification.AlertTextOne") }}
												<span class="text-inherit underline" style="cursor: pointer"
													><feather-icon
														class="cursor-pointer"
														icon="UserPlusIcon"
														svgClasses="h-4 w-4"
													/>
													{{ $t("Resource.AssigResources") }}
												</span>
												{{ $t("Reports.AlertTextTwo") }}
											</vs-alert>
										</p>
									</div>

									<div class="vx-col md:w-1/1 w-full">
										<p v-if="assignedResources.length > 0">
											<vs-alert
												class="mt-2"
												:active.sync="activeAlert3"
												closable
												icon-pack="feather"
												close-icon="icon-x"
												color="success"
												:title="$t('Zonification.AlertSelectLayerTitle')"
											>
												{{ $t("Zonification.AlertSelectLayerText") }}
												{{ $t("Zonification.AlertSelectLayerText2") }}
												<span class="text-inherit underline" style="cursor: pointer">
													<feather-icon
														class="cursor-pointer"
														icon="SaveIcon"
														svgClasses="h-4 w-4"
													/>
												</span>
												{{ $t("Zonification.AlertSelectLayerText3") }}
												<span class="text-inherit underline" style="cursor: pointer">
													<feather-icon
														class="cursor-pointer"
														icon="Trash2Icon"
														svgClasses="h-4 w-4"
													/>
												</span>
												{{ $t("Zonification.AlertSelectLayerText4") }}
											</vs-alert>
										</p>
									</div>
									<div class="vx-col md:w-1/1 w-full" v-if="assignedResources.length > 0">
										<!--capas disponibles -->
										<div class="mt-4">
											<label class="vs-input--label">{{ $t("Zonification.Layers") }}</label>
											<v-select
												v-model="selectedResourceLayer"
												:options="layerOptions"
												:dir="$vs.rtl ? 'rtl' : 'ltr'"
												:placeholder="$t('Select')"
											>
												<template v-slot:no-options="{search, searching}">
													<template v-if="searching">
														{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
													</template>
												</template>
											</v-select>
										</div>
									</div>

									<div class="vx-col md:w-1/1 w-full" v-if="assignedResources.length > 0">
										<!--Layers resorces -->
										<div class="mt-4">
											<label class="vs-input--label">{{ $t("Zonification.Zones") }}</label>
											<treeselect
												v-if="zonesBoolean"
												value-consists-of="LEAF_PRIORITY"
												v-model="zonesCheckedResource"
												:default-expand-level="1"
												:multiple="true"
												:options="optionsMulti"
												openDirection="top"
												@open="(zonesChecked = zonesCheckedResource), (zonesBoolean = false)"
											/>
											<treeselect
												v-else
												value-consists-of="LEAF_PRIORITY"
												v-model="zonesChecked"
												:default-expand-level="1"
												:multiple="true"
												:options="optionsMulti"
												:value="zonesChecked"
											/>
										</div>
									</div>
								</div>
							</div>
						</vs-tab>
					</vs-tabs>
				</vx-card>
			</div>
			<div class="vx-col md:w-3/5 w-full mb-base">
				<vx-card>
					<div class="vx-row">
						<div class="vx-col w-full">
							<drawing-tools
								:global="this"
								:mode="activeTab"
								:idCapa="idCapa"
								:selectedLayer="selectedLayer"
								:selectedZone="selectedZone"
								:selectedResource="assignedResources"
								:zonesSelected="zones"
								:zonesResourceChecked="zonesChecked"
								:modeAssigUpdate="modeAssigUpdate"
								@deleteAssigZoneResourceEmit="confirmDeleteAssigZoneResource"
								@deleteShapeEmit="deleteShape"
								@changeColorEmit="changeColor"
								@nuevaCapaEmit="openCapaPrompt"
								@deleteZoneCapaEmit="deleteZoneCapa"
								@clearMapLayerEmit="clearMapLayer"
								@deleteOnlyCapaEmit="deleteOnlyCapa"
								@editZoneEmit="openEditZonePrompt"
								@changeNameCapaEmit="changeNameCapa"
								@showPopupResourceEmit="showPopup"
								@assigZoneResourceEmit="assigZoneResource"
								@callbackDrawEmit="callbackDraw"
								@featureSelectedEmit="shapeSelectedRemove"
							/>
						</div>
					</div>
					<div class="map-custom-container">
						<ol-map-container
							name="theMap"
							ref="moduleMap"
							latitude="4.686699"
							longitude="-74.0837187"
							zoom="13"
							mapType="here"
							:width="widthMap"
							height="74.3vh"
							@instanceOlMap="olMap = $event"
						>
						</ol-map-container>
					</div>
				</vx-card>
			</div>
			<vs-prompt
				:title="promptCapaTitle"
				@cancel="cancelCapaPromt"
				@accept="acceptCapaAlert"
				@close="closeCapaPrompt"
				:active.sync="activeCapaPrompt"
				:is-valid="nameCapa.length > 0 && statusSelected !== null"
			>
				<div class="con-exemple-prompt">
					<p>{{ $t("Zonification.AssignNameLayer") }}</p>
					<vs-input
						:placeholder="$t('Zonification.AssignNameLayer')"
						:vs-placeholder="$t('Zonification.AssignNameLayer')"
						v-model="nameCapa"
						v-validate="'required'"
						class="mt-3 w-full mb-4"
					/>
				</div>
				<div class="mt-4">
					<label class="vs-input--label">{{ $t("Status") }}</label>
					<v-select
						v-model="status_local_sel"
						:clearable="false"
						:options="statusOptions"
						v-validate="'required'"
						name="status"
						:placeholder="$t('Select')"
					>
						<template v-slot:no-options="{search, searching}">
							<template v-if="searching">
								{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
							</template>
						</template>
					</v-select>
					<span class="text-danger text-sm" v-show="errors.has('status')">{{ errors.first("status") }}</span>
				</div>
			</vs-prompt>
			<vs-prompt
				:title="promptZoneTitle"
				@cancel="cancelPromt"
				@accept="acceptAlert"
				@close="cancelPromt"
				:active.sync="activePrompt"
				:is-valid="nameZone.length > 0"
			>
				<div class="con-exemple-prompt">
					<small v-if="selectedZone.cartodb_id > 0">{{ $t("Zonification.EditZoneSelected") }}</small>
					<small v-else>{{ $t("Zonification.AddZoneInLayer") }}</small>
					<vs-input
						:placeholder="$t('Name')"
						:vs-placeholder="$t('Name')"
						v-model="nameZone"
						v-validate="'required'"
						class="mt-3 w-full mb-4"
					/>

					<vs-input
						:placeholder="$t('Description')"
						:vs-placeholder="$t('Description')"
						v-model="descriptionZone"
						v-validate="'required'"
						name="description"
						class="mt-3 w-full mb-4"
					/>
				</div>
			</vs-prompt>
			<popup-customize
				class="vs-popup--custom"
				:fullscreen="false"
				:title="null"
				:active="resourceMounted"
				:hidden-boolean="true"
			>
				<resource-list
					v-if="resourceMounted"
					ref="ResourceList"
					:removeColumns="true"
					:customConfig="resourceListConfig"
					@showPopupEmmit="showPopup"
					@closePopup="closepopupEmit"
				/>
			</popup-customize>
		</div>
	</div>
</template>

<script>
import vSelect from "vue-select";
import moduleResource from "@/store/resource/moduleResource.js";
import ResourceList from "@/components/resource/user-list/ResourceList.vue";
import moduleVisitPoint from "@/store/visit-point/moduleVisitPoint.js";
import moduleCommon from "@/store/common/moduleCommon.js";
import moduleZonification from "@/store/zonification/moduleZonification.js";
import VisitPoint from "@/models/VisitPoint.js";
import Zone from "@/models/zone.js";
import {v4 as uuidv4} from "uuid";
import carto from "@carto/carto.js";
import FormGeo from "./FormGeo.vue";
import UploadZones from "./UploadZones.vue";
import cartoDB from "@/helpers/cartoDB";
import DrawingTools from "./DrawingTools.vue";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import ResourceItem from "../resource/ResourceItem.vue";
import cartodb from "@/constants/cartodb.js";
import PopupCustomize from "../../core/components/PopupCustomize";
import OlMapContainer from "../../core/components/ol/OlMap";
import {
	addCartoDb,
	clearMap,
	fitBounds,
	getCurrentPosition,
	removeInteraction,
	removeTileLayers,
	setZoom,
} from "../../core/plugins/ol/OlAnuket";
import {infowindowContentLayerCarto} from "../Maps/infowindowContent";

const {cartoTable} = cartodb;

export default {
	components: {
		OlMapContainer,
		PopupCustomize,
		vSelect,
		FormGeo,
		DrawingTools,
		Treeselect,
		UploadZones,
		ResourceList,
		ResourceItem,
	},
	data() {
		return {
			olMap: null,
			colorTabs: "#F9841E",
			zonesCheckedResource: [],
			zonesBoolean: false,
			windowHeight: screen.height,
			visitPoint: new VisitPoint({}),
			promptZoneTitle: this.$t("Zonification.AddZone"),
			promptCapaTitle: this.$t("Zonification.CreateNewLayer"),
			promptZoneEditInfo: false,
			promptCapaEditInfo: false,
			nameCapa: "",
			idCapa: 0,
			nameZone: "",
			selectedZone: new Zone({}),
			descriptionZone: "",
			activeItem: "0",
			shapeSelected: null,
			shapeColor: "#3EC9D6",
			activeTab: 0,
			selected: [],
			selectedLayer: null,
			layers: [],
			options: [],
			client: null,
			description: "",
			activePrompt: false,
			activeCapaPrompt: false,
			mode: "VIEW",
			// define the default value
			zones: [],
			// define options
			optionsMulti: [
				{
					id: "a",
					label: "a",
					children: [
						{
							id: "aa",
							label: "aa",
						},
					],
				},
			],
			activeAlert: false,
			currentCapaDataSelected: null,
			//currentCapaData: [],
			coordinatesPolygon: null,
			alertPolygon: false,
			//
			resourceMounted: false,
			//Config Resource List
			resourceListConfig: {
				rowSelection: "single",
				activeCheckbox: true,
				columns: ["id", "name", "lastname", "username", "email", "identification", "alias", "status"],
				actionDropdown: false,
				btnAssigResources: true,
				popupMode: true,
			},
			activeAlert2: true,
			activeAlert3: true,
			currentResource: null,
			zonesChecked: [],
			zonesResource: [],
			zonesResourceRelations: [],
			modeAssigUpdate: false,
			selectedResourceLayer: null,
			checkedAllResourceLayer: false,
			status: [],
			statusSelected: null,
			layerHere: [],
			polygonsIds: [],
		};
	},
	created() {
		if (!moduleVisitPoint.isRegistered) {
			this.$store.registerModule("moduleVisitPoint", moduleVisitPoint);
			moduleVisitPoint.isRegistered = true;
		}
		if (!moduleResource.isRegistered) {
			this.$store.registerModule("moduleResource", moduleResource);
			moduleResource.isRegistered = true;
		}

		if (!moduleCommon.isRegistered) {
			this.$store.registerModule("moduleCommon", moduleCommon);
			moduleCommon.isRegistered = true;
		}

		if (!moduleZonification.isRegistered) {
			this.$store.registerModule("moduleZonification", moduleZonification);
			moduleZonification.isRegistered = true;
		}
		this.fetchLayerList();
		// Create new client
		this.client = cartoDB.client();
		const payload = {status: []};
		this.$store
			.dispatch("moduleCommon/fetchDataRoleStatusCategoryTypology", payload)
			.then((res) => {
				this.status = res.data.status;
			})
			.catch((err) => {
				throw new Error(err);
			});
	},
	mounted() {
		window.addEventListener("resize", () => {
			this.windowHeight = window.innerHeight;
		});
		getCurrentPosition();
	},
	filters: {
		capitalizeFilter: function (value) {
			if (!value) return "";
			value = value.toString();
			return value.charAt(0).toUpperCase() + value.slice(1);
		},
	},
	watch: {
		activeTab(val) {
			removeInteraction();
			if (val != 1) {
				const cursor = document.querySelector(".map");
				if (cursor != null) cursor.style.cursor = "default";
			}
			this.removeLayersFromMap();
			this.zones = [];
			this.selectedLayer = null;
			if (val === 1) {
				this.$store.commit("moduleZonification/CLEAN_ZONE_ITEMS");
				this.activeAlert = true;
				this.idCapa = 0;
				this.nameCapa = "";
			}
			this.$store.dispatch("moduleResource/cleanResourceActivity");
			this.modeAssigUpdate = false;
			this.zonesChecked = [];
		},
		selected(val) {
			const cartodbIds = val.map(({value}) => value).join(",");
			if (cartodbIds.length > 0) {
				this.drawCartoPolygons(cartodbIds);
			} else {
				this.removeLayersFromMap();
			}
		},
		selectedLayer(val) {
			if (!val) {
				this.removeLayersFromMap();
				clearMap();
				this.zones = [];
				return;
			}
			this.getAllPolygons(val.value);
			this.removeLayersFromMap();
			clearMap();
			this.zones = [];
		},
		zones(val) {
			if (this.selectedLayer) {
				if (val[0] === this.selectedLayer.value) {
					this.drawCartoLayer(this.selectedLayer.value);
					return;
				}
			}
			const cartodbIds = val.map((value) => value).join(",");
			if (cartodbIds.length > 0) {
				this.drawCartoPolygons(cartodbIds);
			} else {
				this.removeLayersFromMap();
				this.selectedZone = new Zone({});
				setZoom(10);
			}
		},
		currentCapaDataSelected(val) {
			if (this.selectedLayer) {
				if (val[0] === this.selectedLayer.value) {
					this.drawCartoLayer(this.selectedLayer.value);
					return;
				}
			}
			const cartodbIds = val.map((value) => value).join(",");
			if (cartodbIds.length > 0) {
				this.drawCartoPolygons(cartodbIds);
			} else {
				this.removeLayersFromMap();
				this.selectedZone = new Zone({});
				setZoom(10);
			}
		},
		promptCapaEditInfo(val) {
			val
				? (this.promptCapaTitle = this.$t("Zonification.UpdateNameLayer"))
				: (this.promptCapaTitle = this.$t("Zonification.CreateNewLayer"));
		},
		assignedResources(val) {
			if (val.length > 0) {
				this.getAssigedZoneResource(val[0].id);
			}
		},
		selectedResourceLayer(val) {
			if (!val) {
				this.removeLayersFromMap();
				this.zonesChecked = [];
				this.zonesCheckedResource = [];
				return;
			}
			this.getAllResourcePolygons();
			this.removeLayersFromMap();
			this.zonesChecked = [];
			this.zonesCheckedResource = [];
		},
		zonesChecked(val) {
			if (this.selectedResourceLayer) {
				if (val[0] === this.selectedResourceLayer.value) {
					this.drawCartoLayer(this.selectedResourceLayer.value);
					this.checkedAllResourceLayer = true;
					return;
				} else {
					this.checkedAllResourceLayer = false;
				}
			}
			const cartodbIds = val.map((value) => value).join(",");
			if (cartodbIds.length > 0) {
				this.drawCartoPolygons(cartodbIds);
			} else {
				this.removeLayersFromMap();
			}
		},
	},
	computed: {
		windowWidth() {
			return this.$store.state.windowWidth;
		},
		widthMap() {
			let widthValue = "";
			if (this.$store.state.reduceButton && this.windowWidth > 767) {
				widthValue = "49.2vw";
			} else if (this.windowWidth > 767) {
				widthValue = "41.2vw";
			} else if (this.windowWidth < 767) {
				widthValue = "100%";
			}
			return widthValue;
		},
		height() {
			let newHeight = 500;
			if (this.windowHeight > 800) {
				newHeight = screen.height * 0.461;
			}
			return newHeight;
		},
		zonificationReadPermission() {
			return this.$store.getters.checkPermission("ZONIFICATION_R");
		},
		zonificationCreatePermission() {
			return this.$store.getters.checkPermission("ZONIFICATION_C");
		},
		zonificationUpdatePermission() {
			return this.$store.getters.checkPermission("ZONIFICATION_U");
		},
		zonificationDeletePermission() {
			return this.$store.getters.checkPermission("ZONIFICATION_D");
		},
		validateForm() {
			return !this.errors.any();
		},
		layerOptions() {
			return this.generateOptionSelect(this.$store.state.moduleZonification.layers, "name", "id");
		},
		statusOptions() {
			return this.generateOptionSelect(this.status, "name", "id");
		},
		currentCapaData() {
			return this.$store.state.moduleZonification.zones;
		},
		assignedResources() {
			return this.$store.state.moduleResource ? this.$store.state.moduleResource.resourcesActivity : [];
		},
		getCurrentResourceChecked() {
			return 0;
		},
		status_local_sel: {
			get() {
				return this.statusSelected;
			},
			set(val) {
				this.statusSelected = val;
			},
		},
	},
	methods: {
		removeAssignedResource(id) {
			// Delete item form store
			this.$store.dispatch("moduleResource/removeResourceActivity", id);
			this.modeAssigUpdate = false;
			this.zonesChecked = [];
			this.selectedLayer = null;
			this.zonesResource = [];
			this.removeLayersFromMap();
			setZoom(11);
		},
		showPopup(val) {
			this.resourceMounted = val;
			if (val) this.optionsMulti = [];
		},
		closepopupEmit(val) {
			this.resourceMounted = val;
			if (val) this.optionsMulti = [];
		},
		generateOptionsMulti(rows) {
			let data = {
				id: this.activeTab === 3 ? this.idCapa : this.selectedLayer.value,
				label: this.selectedLayer.label,
				children: [],
			};
			data.children = rows.map((r) => {
				return {
					id: r.cartodb_id,
					label: r.name,
					isDisabled: false,
					//value: r,
				};
			});
			this.optionsMulti = [data];
		},
		cancelCapaPromt() {
			this.activeAlert = true;
		},
		closeCapaPrompt() {
			this.activeAlert = true;
		},
		acceptCapaAlert() {
			if (this.promptCapaEditInfo) {
				this.updateLayerName();
			} else {
				this.createLayer();
			}
		},
		openCapaPrompt() {
			this.promptCapaEditInfo = false;
			this.activeCapaPrompt = true;
			this.nameCapa = "";
		},
		cancelPromt() {
			this.deleteShape();
		},
		acceptAlert() {
			if (this.selectedZone.cartodb_id > 0) {
				this.updateZoneInfo();
			} else {
				this.insertZone();
			}
		},
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		capitalize(str = "") {
			return str.slice(0, 1).toUpperCase() + str.slice(1, str.length);
		},
		createLayer() {
			const payload = {
				name: this.nameCapa,
				status_id: this.statusSelected.value,
			};
			if (!payload.status_id) {
				this.openCapaPrompt();
				return;
			}
			this.openLoading();
			this.$store
				.dispatch("moduleZonification/addLayerItem", payload)
				.then((res) => {
					this.idCapa = parseInt(res);
					this.selectedLayer = {
						label: this.nameCapa,
						value: this.idCapa,
					};

					const newCapa = {
						id: this.idCapa,
						label: this.nameCapa,
						children: [
							{
								id: "aa",
								label: "aa",
							},
						],
					};

					if (this.activeTab === 2) {
						this.$store.dispatch("moduleZonification/addZoneItems", newCapa);
					}
					this.alertPolygon = true;
					this.closeLoading();
				})
				.catch((error) => {
					this.closeLoading();
					throw new Error(error);
				});
		},
		fetchLayerList() {
			this.$store
				.dispatch("moduleZonification/fetchLayerListItems")
				.then((res) => {
					if (Array.isArray(res.data)) {
						this.layers = res.data;
					}
				})
				.catch((error) => {
					throw new Error(error);
				});
		},
		updateLayerName() {
			const payload = {
				name: this.nameCapa,
				id: this.selectedLayer.value,
				status_id: this.statusSelected.value,
			};
			if (!payload.status_id) {
				this.openCapaPrompt();
				return;
			}
			this.openLoading();
			this.$store
				.dispatch("moduleZonification/updateLayerItem", payload)
				.then((res) => {
					this.closeLoading();
					this.$vs.notify({
						color: "success",
						title: this.$t("Zonification.UpdateLayerSuccess.Title"),
						text: this.$t("Zonification.UpdateLayerSuccess.Text"),
					});
				})
				.catch((error) => {
					this.closeLoading();
					throw new Error(error);
				});
		}, //
		getAllPolygons(layerId) {
			cartoDB
				.executeQuery(`SELECT * FROM ${cartoTable} WHERE layer LIKE '${layerId}'`)
				.then((res) => {
					this.options = this.generateOptionSelect(res.data.rows, "name", "cartodb_id");
					this.polygonsIds = res.data.rows.map(({cartodb_id}) => cartodb_id);
					this.generateOptionsMulti(res.data.rows);
				})
				.catch((err) => {
					throw new Error(err);
				});
		},
		removeLayersFromMap() {
			return new Promise((resolve, reject) => {
				const layers = this.client.getLayers();
				if (layers.length > 0) {
					layers.forEach((layer) => {
						this.client
							.removeLayer(layer)
							.then(() => {
								removeTileLayers();
								resolve("Layer removed");
							})
							.catch((error) => {
								reject(error.message);
							});
					});
				} else {
					resolve("Layer removed");
				}
			});
		},
		drawCartoLayer(layerId) {
			const dataset = new carto.source.SQL(`SELECT * FROM ${cartoTable} WHERE layer LIKE '${layerId}'`);
			const style = new carto.style.CartoCSS(`
              #layer {
              polygon-fill: #FFFF00;
                polygon-opacity: 0.5;
                line-color: #000000;
                line-width: 0.5;
                line-opacity: 1;
                line-dasharray: 10, 5;
              }
            `);
			// new
			const table_name_carto = cartoTable;
			const source_base = new carto.source.Dataset(table_name_carto);
			const style_base = new carto.style.CartoCSS(`
              #layer {
                  polygon-fill: #FFFF00;
                  polygon-opacity: 0.5;
                  line-color: #000000;
                  line-width: 0.5;
                  line-opacity: 1;
                  line-dasharray: 10, 5;
              }
            `);
			const source_styles = new carto.source.SQL(
				`SELECT *, CASE WHEN (cartodb_id in (0)) then '1' ELSE '0' END as style_layer FROM ${table_name_carto} WHERE layer LIKE '${layerId}'`
			);
			const style2 = new carto.style.CartoCSS(`
              #layer {
              polygon-fill: #FF0000;
                polygon-opacity: 0.5;
                line-color: #000000;
                line-width: 0.5;
                line-opacity: 1;
                line-dasharray: 10, 5;
              }
            `);
			let layer = new carto.layer.Layer(dataset, style2, {
				featureClickColumns: ["name", "layer", "description", "cartodb_id"],
			});
			this.renderLayer(layer);
		},
		fitBoundGeoJson(cartodbIds) {
			cartoDB
				.executeQueryWithBounds(
					`WITH bbox as (SELECT ST_Envelope(the_geom) as the_geom FROM ${cartoTable} WHERE cartodb_id IN (${cartodbIds}))
                                    SELECT the_geom, ST_Xmax(the_geom) as xmax,
                                    ST_Ymax(the_geom) as ymax,
                                    ST_Xmin(the_geom) as  xmin,
                                    ST_Ymin(the_geom) as ymin
                                    FROM bbox`
				)
				.then((res) => {
					let geoJson = null;
					if (res.data.features.length > 1) {
						let aux = [];
						res.data["features"].forEach((elem, index) => {
							aux[index] = elem.properties;
						});
						let xmin = aux[0].xmin;
						let xmax = aux[0].xmax;
						let ymin = aux[0].ymin;
						let ymax = aux[0].ymax;
						aux.forEach((item, index) => {
							if (xmin > aux[index].xmin) {
								xmin = aux[index].xmin;
							}
							if (xmax < aux[index].xmax) {
								xmax = aux[index].xmax;
							}
							if (ymin > aux[index].ymin) {
								ymin = aux[index].ymin;
							}
							if (ymax < aux[index].ymax) {
								ymax = aux[index].ymax;
							}
						});
						geoJson = {properties: {xmin: xmin, xmax: xmax, ymin: ymin, ymax: ymax}};
					} else {
						geoJson = res.data["features"][res.data["features"].length - 1];
					}
					const minLon = geoJson["properties"]["xmin"];
					const minLat = geoJson["properties"]["ymin"];
					const maxLon = geoJson["properties"]["xmax"];
					const maxLat = geoJson["properties"]["ymax"];
					const extent = [minLon, minLat, maxLon, maxLat];
					fitBounds(extent, "Features");
				});
		},
		drawCartoPolygons(cartodbIds) {
			const source = new carto.source.SQL(`SELECT * FROM ${cartoTable} WHERE cartodb_id IN (${cartodbIds})`);
			// Create style for the data
			const style = new carto.style.CartoCSS(`
              #layer {
               polygon-fill: #FF5C00;
                polygon-opacity: 0.5;
                line-color: #F3F3F3;
                line-width: 0.5;
                line-opacity: 1;
                line-dasharray: 10, 5;
              }
            `);
			// Add style to the data
			const layer = new carto.layer.Layer(source, style, {
				featureClickColumns: ["name", "layer", "description", "cartodb_id"],
			});
			this.renderLayer(layer);
			this.fitBoundGeoJson(cartodbIds);
		},
		generateOptionSelect(data, propLabel, propValue) {
			if (Array.isArray(data) && data.length > 0) {
				return data.map((d) => {
					return {label: d[propLabel], value: d[propValue]};
				});
			} else {
				return [];
			}
		},
		callbackDraw(shape) {
			shape["id"] = uuidv4();
			this.shapeSelected = shape;
			switch (shape["type"]) {
				case "Polygon":
					const geometry = shape.getGeometry().transform("EPSG:3857", "EPSG:4326");
					this.coordinatesPolygon = geometry.getCoordinates()[0];
					this.polygonManager();
					shape.getGeometry().transform("EPSG:4326", "EPSG:3857");
					break;
				case "Circle":
					this.circleManager(shape);
					break;
				default:
					break;
			}
		},
		shapeSelectedRemove(feature) {
			this.shapeSelected = null;
			this.shapeSelected = feature;
		},
		deleteShape() {
			if (this.shapeSelected === null) {
				return;
			}
			this.olMap.vec.getSource().removeFeature(this.shapeSelected);
			this.shapeSelected = null;
		},
		changeColor(fillColor) {
			this.shapeSelected.setOptions({fillColor});
		},
		replacePoligon() {
			const query = cartoDB.generateUpdateQuery(this.coordinatesPolygon, this.selectedZone.cartodb_id);
			cartoDB
				.executeQuery(query)
				.then((res) => {
					this.$vs.notify({
						color: "success",
						title: this.$t("Zonification.UpdateZone.Title"),
						text: this.$t("Zonification.UpdateZone.Text"),
					});
					this.zones = [];
					this.selectedZone = new Zone({});
					this.deleteShape();
					setZoom(10);
				})
				.catch((err) => {
					throw new Error(err);
				});
		},
		polygonManager() {
			switch (this.activeTab) {
				case 0:
					break;
				case 1:
					if (this.selectedZone.cartodb_id > 0) {
						this.$vs.dialog({
							type: "confirm",
							color: "primary",
							title: this.$t("Zonification.ReplacePolygonConfirmTitle"),
							text: this.$t("Zonification.ReplacePolygonConfirmText"),
							accept: this.replacePoligon,
							acceptText: this.$t("Replace"),
							cancelText: this.$t("Cancel"),
						});
					} else {
						this.activePrompt = true;
						this.nameZone = "";
						this.descriptionZone = "";
					}
					break;
				case 2:
					this.selectedZone = new Zone({});
					this.activePrompt = true;
					this.nameZone = "";
					this.descriptionZone = "";
					break;
				default:
					break;
			}
		},
		circleManager(shape) {
			if (this.activeTab === 0) {
				const geometry = shape.getGeometry().transform("EPSG:3857", "EPSG:4326");
				let radius = geometry.getRadius();
				let centerLat = geometry.getCenter()[1];
				let centerLng = geometry.getCenter()[0];
				shape.getGeometry().transform("EPSG:4326", "EPSG:3857");
				const source = new carto.source.SQL(`
            SELECT name, layer, cartodb_id, description, the_geom, the_geom_webmercator
            FROM ${cartoTable}
            WHERE ST_intersects(
                the_geom,
                ST_Buffer(
                  ST_SetSRID(ST_Point(${centerLng},${centerLat}),4326)::geography,
                  ${radius})::geometry
                )
        `);

				// Create style for the data
				const style = new carto.style.CartoCSS(`
          #layer {
          polygon-fill: #FF5C00;
            polygon-opacity: 0.5;
            line-color: #FFFFFF;
            line-width: 0.5;
            line-opacity: 1;
            line-dasharray: 10, 5;
          }
        `);
				const layer = new carto.layer.Layer(source, style, {
					featureClickColumns: ["name", "layer", "description", "cartodb_id"],
				});
				this.renderLayer(layer);
			}
		},
		insertZone() {
			const data = {
				description: this.descriptionZone,
				layer: this.activeTab === 2 ? this.idCapa : this.selectedLayer.value,
				name: this.nameZone,
				coordinates: this.coordinatesPolygon,
			};
			const zone = new Zone(data);
			const validateCreateTableQuery = cartoDB.validateCreateTableQuery();
			const queryCreateTable = cartoDB.generateCreateTableQuery();
			const query = cartoDB.generateCreateQuery(zone);
			this.openLoading();
			cartoDB
				.executeQuery(validateCreateTableQuery)
				.then((res) => {
					if (res.data.rows[0].exists) {
						return true;
					}
					return cartoDB.executeQuery(queryCreateTable);
				})
				.then(() => {
					return cartoDB.executeQuery(query);
				})
				.then((res) => {
					this.$vs.notify({
						color: "success",
						title: this.$t("Zonification.AddZones.Title"),
						text: this.$t("Zonification.AddZones.Text"),
					});
					this.getAllPolygons(this.activeTab === 2 ? this.idCapa : this.selectedLayer.value);
					this.closeLoading();
					this.deleteShape();
					return res;
				})
				.catch((err) => {
					this.closeLoading();
					this.$vs.notify({
						color: "danger",
						title: this.$t("Zonification.ErrorInsertZones.Title"),
						text: this.$t("Zonification.ErrorInsertZones.Text"),
					});
					throw new Error(err);
				});
		},
		delete(all = false) {
			const cartodbIds = all ? this.polygonsIds : this.zones.map((val) => val);
			const cartodbIdsJoin = cartodbIds.join(",");
			if (cartodbIdsJoin.length > 0) {
				const query = cartoDB.generateDeleteZoneQuery(this.selectedLayer.value, cartodbIdsJoin);
				this.openLoading();
				cartoDB
					.executeQuery(query)
					.then((res) => {
						const payload = {zone_id: cartodbIds};
						return this.$store.dispatch("moduleZonification/removeRelationshipLayerResource", payload);
					})
					.then((res) => {
						this.closeLoading();
						this.infowindow.close();
						this.$vs.notify({
							color: "success",
							title: this.$t("Zonification.RemoveZoneMessage.Title"),
							text: this.$t("Zonification.RemoveZoneMessage.Text"),
						});
						if (all) {
							this.optionsMulti = [];
						} else {
							this.getAllPolygons(this.activeTab === 2 ? this.idCapa : this.selectedLayer.value);
						}
						this.selectedZone = new Zone({});
						this.removeLayersFromMap();
						//this.zones = [];
					})
					.catch((err) => {
						this.closeLoading();
						if (
							err.data === "zone_id not found" &&
							err.message === "Unexpected Error" &&
							err.status === 400
						) {
							let aux = [];
							this.optionsMulti[0]["children"].forEach((elem, index) => {
								if (!cartodbIds.includes(elem.id)) {
									aux.push(elem);
								}
							});
							this.optionsMulti[0]["children"] = aux;
							this.selectedZone = new Zone({});
							this.removeLayersFromMap();
							this.$nextTick(() => (this.zones = []));
							return;
						}
						this.$vs.notify({
							color: "danger",
							title: this.$t("Zonification.ErrorRemoveZones.Title"),
							text: this.$t("Zonification.ErrorRemoveZones.Text"),
						});
						throw new Error(err);
					});
			}
		},
		deleteAllZonesFromCarto() {
			const query = cartoDB.generateDeleteAllZonesQuery(this.selectedLayer.value);
			this.openLoading();
			const p1 = cartoDB.executeQuery(query);
			const p2 = this.$store.dispatch("moduleZonification/removeLayerItem", this.selectedLayer.value);
			Promise.all([p1, p2]).then(
				(values) => {
					// Eliminar todas las zonas de la capa tambn
					const all = true;
					this.delete(all);
					this.getAllPolygons(this.activeTab === 2 ? this.idCapa : this.selectedLayer.value);
					this.closeLoading();
					this.selectedZone = new Zone({});
					this.removeLayersFromMap();
					this.zones = [];
					this.selectedLayer = null;
					this.$vs.notify({
						color: "success",
						title: this.$t("Zonification.RemoveZonesInLayer.Title"),
						text: this.$t("Zonification.RemoveZonesInLayer.Text"),
					});
				},
				(reason) => {
					this.closeLoading();
					this.$vs.notify({
						color: "danger",
						title: this.$t("Zonification.ErrorRemoveZonesInLayer.Title"),
						text: this.$t("Zonification.ErrorRemoveZonesInLayer.Text"),
					});
				}
			);
		},
		deleteOnlyCapa() {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Zonification.RemoveLayer.Title"),
				text: this.$t("Zonification.RemoveLayer.Text"),
				accept: this.deleteAllZonesFromCarto,
				acceptText: this.$t("Crud.Delete"),
				cancelText: this.$t("Cancel"),
			});
		},
		updateZoneInfo() {
			this.selectedZone.name = this.nameZone;
			this.selectedZone.description = this.descriptionZone;
			const query = cartoDB.generateUpdateQueryZoneInfo(this.selectedZone);
			this.openLoading();
			cartoDB
				.executeQuery(query)
				.then((res) => {
					this.$vs.notify({
						color: "success",
						title: this.$t("Zonification.UpdateZone.Title"),
						text: this.$t("Zonification.UpdateZone.Text2"),
					});
					this.getAllPolygons(this.activeTab === 2 ? this.idCapa : this.selectedLayer.value);
					this.closeLoading();
					this.selectedZone = new Zone({});
				})
				.catch((err) => {
					this.closeLoading();
					this.$vs.notify({
						color: "danger",
						title: this.$t("Zonification.ErrorUpdateZoneInfo.Title"),
						text: this.$t("Zonification.ErrorUpdateZoneInfo.Text"),
					});
					throw new Error(err);
				});
		},
		openEditZonePrompt() {
			this.activePrompt = true;
			this.nameZone = this.selectedZone.name;
			this.descriptionZone = this.selectedZone.description;
		},
		clearMapLayer() {
			clearMap();
			this.zones = [];
		},
		deleteZoneCapa() {
			if (this.zones.length <= 0) {
				this.$vs.notify({
					color: "warning",
					title: this.$t("Zonification.SelectZones.Title"),
					text: this.$t("Zonification.SelectZones.Text"),
				});
				return;
			}

			if (this.zones[0] === this.selectedLayer.value) {
				this.$vs.dialog({
					type: "confirm",
					color: "danger",
					title: this.$t("Zonification.ConfirmRemoveLayerAndZones.Title"),
					text: this.$t("Zonification.ConfirmRemoveLayerAndZones.Text"),
					accept: this.deleteAllZonesFromCarto,
					acceptText: this.$t("Crud.Delete"),
					cancelText: this.$t("Cancel"),
				});
				return;
			} else {
				this.$vs.dialog({
					type: "confirm",
					color: "danger",
					title: this.$t("Zonification.ConfirmRemoveSelectedZones.Title"),
					text: this.$t("Zonification.ConfirmRemoveSelectedZones.Text"),
					accept: this.delete,
					acceptText: this.$t("Crud.Delete"),
					cancelText: this.$t("Cancel"),
				});
			}
		},
		changeNameCapa() {
			this.promptCapaEditInfo = true;
			this.activeCapaPrompt = true;
			this.nameCapa = this.selectedLayer.label ? this.selectedLayer.label : "";
		},
		// METHODS FOR ASSIG ZONES TO RESOURCES
		assigZoneResource() {
			if (this.modeAssigUpdate) this.updateAssigZoneResource();
			else this.createAssigZoneResource();
		},
		createAssigZoneResource() {
			const resource_id = this.assignedResources.map((r) => r.id)[0];
			let zone_id = [];
			if (this.checkedAllResourceLayer) {
				zone_id = this.optionsMulti[0].children.map(({id}) => id);
			} else {
				zone_id = this.zonesChecked.map((val) => val);
			}
			this.openLoading();
			this.$store
				.dispatch("moduleZonification/createAssigZoneResource", {
					resource_id,
					zone_id,
				})
				.then((res) => {
					this.zonesResourceRelations = res.data.relationship;
					this.closeLoading();
					this.modeAssigUpdate = true;
					this.$vs.notify({
						color: "success",
						title: this.$t("Zonification.CreateAssignationSuccess"),
						text: this.$t("Zonification.CreateAssignationSuccessText"),
					});
				})
				.catch((err) => {
					this.closeLoading();
					this.errorAlert();
					throw new Error(err);
				});
		},
		updateAssigZoneResource() {
			let zone_id = [];
			if (this.checkedAllResourceLayer) {
				zone_id = this.optionsMulti[0].children.map(({id}) => id);
			} else if (this.zonesChecked.length > 0) {
				zone_id = this.zonesChecked.map((val) => val);
			} else {
				zone_id = this.zonesCheckedResource.map((val) => val);
			}
			const resource_id = this.assignedResources.map((r) => r.id)[0];
			this.openLoading();
			this.$store
				.dispatch("moduleZonification/updateAssigZoneResource", {
					resource_id,
					zone_id,
				})
				.then((res) => {
					this.zonesResourceRelations = res.data.relationship;
					this.closeLoading();
					this.$vs.notify({
						color: "success",
						title: this.$t("Zonification.UpdateAssignationSuccess"),
						text: this.$t("Zonification.UpdateAssignationSuccessText"),
					});
				})
				.catch((err) => {
					this.closeLoading();
					this.errorAlert();
					throw new Error(err);
				});
		},
		deleteAssigZoneResource() {
			let delZonesResourceRelations = [];
			if (this.checkedAllResourceLayer) {
				delZonesResourceRelations = this.zonesResourceRelations;
			} else if (this.zonesChecked.length > 0) {
				// To delete assignations is necessary filter by all of checked zones
				delZonesResourceRelations = this.zonesResourceRelations
					.filter((res) => this.zonesChecked.some((zone) => zone === res.zone_id))
					.map((res) => res);
			} else {
				// To delete assignations is necessary filter by all of checked zones
				delZonesResourceRelations = this.zonesResourceRelations
					.filter((res) => this.zonesCheckedResource.some((zone) => zone === res.zone_id))
					.map((res) => res);
			}
			this.openLoading();
			Promise.all(
				delZonesResourceRelations.map((res) =>
					this.$store.dispatch("moduleZonification/deleteAssigZoneResource", res.id)
				)
			).then(
				(values) => {
					this.closeLoading();
					const resource_id = this.assignedResources.map((r) => r.id)[0];
					this.removeAssignedResource(resource_id);
					this.$vs.notify({
						color: "success",
						title: this.$t("Zonification.DeleteAssignationSuccess"),
						text: this.$t("Zonification.DeleteAssignationSuccessText"),
					});
					setZoom(11);
				},
				(reason) => {
					this.closeLoading();
					this.errorAlert();
					throw new Error(reason);
				}
			);
		},
		getAssigedZoneResource(resourceId) {
			this.openLoading();
			this.$store
				.dispatch("moduleZonification/assignedZoneResourceById", resourceId)
				.then((res) => {
					if (res) {
						this.zonesResourceRelations = res;
						this.zonesResource = res.map(({zone_id}) => zone_id); //.join(",");
						// Get Layer By Zone (res[0].zone_id);
						this.modeAssigUpdate = true;
						return cartoDB.executeQuery(
							`SELECT layer FROM ${cartoTable} WHERE cartodb_id = ${res[0].zone_id} limit 1`
						);
					} else {
						this.modeAssigUpdate = false;
						throw {err: "no found zones "};
					}
				})
				.then((res) => {
					if (res) {
						// Set found layer by resource
						const zoneData = res.data.rows.length > 0 ? res.data.rows[0] : 0;
						const layerFound = this.layerOptions.find((l) => l.value === parseInt(zoneData.layer));
						if (layerFound) {
							this.selectedResourceLayer = layerFound;
							// Obtener poligonos de layer  encontrada
							return cartoDB.executeQuery(
								`SELECT * FROM ${cartoTable} WHERE layer LIKE '${zoneData.layer}'`
							);
						}
					} else {
						throw {err: "no found data for current layers in cartodb"};
					}
				})
				.then((res) => {
					if (res) {
						this.options = this.generateOptionSelect(res.data.rows, "name", "cartodb_id");
						let data = {
							id: this.selectedResourceLayer.value,
							label: this.selectedResourceLayer.label,
							children: [],
						};
						data.children = res.data.rows.map((r) => {
							return {
								id: r.cartodb_id,
								label: r.name,
								isDisabled: false,
							};
						});
						this.optionsMulti = [data];
						if (this.zonesResource.length > 0) {
							this.zonesBoolean = true;
							this.zonesCheckedResource = this.zonesResource;
							this.drawCartoPolygons(this.zonesResource.join(","));
						}
					} else {
						throw {err: "no found zones for current layers in cartodb"};
					}
					this.closeLoading();
				})
				.catch((err) => {
					this.closeLoading();
					this.selectedResourceLayer = null;
					console.error(err);
				});
		},
		getAllResourcePolygons() {
			cartoDB
				.executeQuery(`SELECT * FROM ${cartoTable} WHERE layer LIKE '${this.selectedResourceLayer.value}'`)
				.then((res) => {
					this.options = this.generateOptionSelect(res.data.rows, "name", "cartodb_id");
					let data = {
						id: this.selectedResourceLayer.value,
						label: this.selectedResourceLayer.label,
						children: [],
					};
					data.children = res.data.rows.map((r) => {
						return {
							id: r.cartodb_id,
							label: r.name,
							isDisabled: false,
						};
					});
					this.optionsMulti = [data];
				})
				.catch((err) => {
					throw new Error(err);
				});
		},
		confirmDeleteAssigZoneResource() {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Zonification.DeleteZoneResourceConfirmTitle"),
				text: this.$t("Zonification.DeleteZoneResourceConfirmText"),
				accept: this.deleteAssigZoneResource,
				acceptText: this.$t("Crud.Delete"),
				cancelText: this.$t("Cancel"),
			});
		},
		errorAlert() {
			this.$vs.notify({
				color: "danger",
				title: this.$t("ErrorTitle"),
				text: this.$t("ErrorMessage"),
			});
		},
		renderLayer(layer) {
			this.removeLayersFromMap().then(() => {
				// Add the data to the map as a layer
				this.client.addLayer(layer);
				let options = {
					title: this.$t("MapModule.CurrentPosition"),
					activatePopup: true,
					onClick: (e) => {
						this.selectedZone = new Zone(e.info);
					},
					onClose: () => {
						this.selectedZone = new Zone({});
					},
				};
				addCartoDb(layer.getSource().getQuery(), options);
			});
		},
	},
};
</script>
<style lang="scss" scoped>
.tabResponsive {
	overflow-y: visible;
	overflow-x: hidden;
}

hr {
	border: 1px solid #d6d6d6;
}
</style>
